import React from "react";
import { GitBranch, Radio } from "lucide-react";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" }) : "—");
const num = (n) => (n == null ? "—" : Number(n).toLocaleString());

/** Hub: the three channels — all follow live hub data — and the (historical) promotion trail. */
export function ChannelsPanel({ channels, promotions }) {
    return (
        <div className="bg-[#0a0a0a] border border-white/10 rounded-md p-6" data-testid="channels-panel">
            <div className="flex flex-wrap items-center justify-between gap-2 mb-4">
                <div className="flex items-center gap-2">
                    <GitBranch className="w-4 h-4 text-[#7C3AED]" strokeWidth={1.5} />
                    <div className="font-display text-lg tracking-tight">Channels</div>
                </div>
                <div className="text-[11px] text-white/50" data-testid="channels-policy">Every channel follows live hub data — environments receive each change on their next sync.</div>
            </div>
            <div className="grid md:grid-cols-3 gap-3">
                {(channels || []).map((ch) => (
                    <div key={ch.channel} className="rounded border border-white/10 bg-[#050505] p-4" data-testid={`channel-card-${ch.channel}`}>
                        <div className="flex items-center justify-between">
                            <div className="font-display text-xl">{ch.channel}</div>
                            <span className="inline-flex items-center gap-1 rounded px-2 py-0.5 text-[11px] bg-emerald-400/10 text-emerald-200 border border-emerald-400/30" data-testid={`channel-mode-${ch.channel}`}>
                                <Radio className="w-3 h-3" /> follows live
                            </span>
                        </div>
                        <div className="mt-3 text-xs text-white/60 font-mono">
                            visible <span className="text-white/90" data-testid={`channel-visible-${ch.channel}`}>{num(ch.visible_seq)}</span> / live {num(ch.live_seq)}
                        </div>
                    </div>
                ))}
            </div>
            {!!promotions?.length && (
                <div className="mt-5">
                    <div className="label-xs mb-2">Promotion history (before the live-sync policy)</div>
                    <ul className="text-xs space-y-1" data-testid="promotions-list">
                        {promotions.slice(0, 6).map((p) => (
                            <li key={p.promotion_id} className="flex flex-wrap items-center gap-2 border-t border-white/5 py-1.5">
                                <span className="font-mono text-white/80">{p.source} → {p.target}</span>
                                <span className="text-white/40">{fmt(p.at)}</span>
                                <span className="text-white/60">{p.actor}</span>
                                <span className="ml-auto font-mono text-white/50">{num(p.from_seq)} → {num(p.to_seq)}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
}
